import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Customer } from "../../../../core/api/models";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import { State } from "../../../../core/store/interfaces";
import {
  useLead,
  AppPermissions,
  useHasPermission,
  LeadAssigneeChangeReason
} from "../../../../core";
import AutoCompleteInput from "../../../../components/form-group/auto-complete-input";
import SalesPersonsAutoCompleteInput from "../../../../components/form-group/sales-persons-auto-complete-input";
import { useDataLoader } from "react-remote-data-hooks";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import { ConfirmationModal } from "./confirmation-modal";
import PersonnelChangeModal from "./personnel-change-modal";

export enum AssigneeAccountType {
  GroupManager = 'GroupManager',
  Telecaller = 'Telecaller',
  LeadManager = 'LeadManager',
  IntercityUser = 'IntercityUser',
}

export enum LeadAssigneeType {
  Telecaller = 'telecaller',
  LeadManager = 'leadManager',
  GroupManager = 'groupManager',
  IntercityUser = 'intercityUser'
}

const AssignUsers: React.FunctionComponent<{ onUpdate?: () => void }> = (
  props
) => {
  const leadState = useSelector((state: State) => state.lead);
  const appSettings = useAppSettings(api.settings);
  const canAssignCRMAgent = useHasPermission(AppPermissions.AssignCRMAgent);
  // const canAssignLeadAssigneeHead = useHasPermission(AppPermissions.canAssignLeadAssigneeHead);
  const canAssignLeadAssigneeHead = true
  // const canLeadAssigneeHead = useHasPermission(AppPermissions.CanLeadAssigneeHead);
  const canLeadAssigneeHead = true
  const canUpdateCrmAgent = useHasPermission(AppPermissions.CanUpdateCrmAgent);
  const canAssignSalesPerson = useHasPermission(
    AppPermissions.AssignSalesPerson
  );
  const canUpdateSalesPerson = useHasPermission(
    AppPermissions.CanUpdateSalesPerson
  );
  const canAssignIntercityUser = useHasPermission(
    AppPermissions.AssignIntercityUser
  );
  const canUpdateIntercityUser = useHasPermission(
    AppPermissions.CanUpdateIntercityUser
  );
  const canAssignLeadManager = useHasPermission(
    AppPermissions.AssignLeadManager
  );

  const canUpdateLeadManager = useHasPermission(
    AppPermissions.CanUpdateLeadManager
  );

  const canAssignGroupManager = useHasPermission(
    AppPermissions.AssignGroupManager
  );

  const canUpdateGroupManager = useHasPermission(
    AppPermissions.CanUpdateGroupManager
  );

  const canAssignTelecaller = useHasPermission(
    AppPermissions.AssignTelecaller
  );

  const canUpdateTelecaller = useHasPermission(
    AppPermissions.CanUpdateTelecaller
  );

  const [
    isCustomerReqSalesPerson,
    setIsCustomerReqSalesPerson,
  ] = useState<boolean>(
    leadState?.leadDetails?.customerReqSalesPerson || false
  );
  const { assignCrmAgent, assignSalesPerson, updating, assignLeadAssigneeHead, updateAssignee } = useLead(api.lead);

  const { data: changeReasons } = useDataLoader<LeadAssigneeChangeReason[]>(
    () => api.changeLeadAssigneeUserReasonService.loadAllChangeLeadAssigneeRejectReason({ entityType: 'LeadAssigneeChange' })
  );

  const [isSalesPersonChanging, setSalesPersonChanging] = useState(false);
  const [isCrmAgentChanging, setCrmAgentChanging] = useState(false);
  const [isLeadAssigneeHeadChanging, setLeadAssigneeHeadChanging] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [showLeadAssigneeHeadReasonModal, setLeadAssigneeHeadShowReasonModal] = useState(false);
  const [showSalesReasonModal, setShowSalesReasonModal] = useState(false);
  const [selectReason, setSelectReason] = useState(true);
  const [change, setChange] = useState(false);
  const [selectedCRM, setSelectedCRM] = useState<Customer>();
  const [selectedLeadAssigneeHead, setSelectedLeadAssigneeHead] = useState<Customer>();
  const [selectedSalesPerson, setSelectedSalesPerson] = useState<Customer>();
  const [selectedInterCityUser, setSelectedInterCityUser] = useState<Customer>();
  const [reason, setReason] = useState<LeadAssigneeChangeReason>();
  const [callCenterExeAssignConfirmation, setCallCenterExeAssignConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });
  const [leadHeadAssignConfirmation, setLeadHeadAssignConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });
  const [agentTransactionManagerConfirmation, setTransactionManagerConfirmation] = useState<{ isOpen?: boolean; salesPersonReqStatus?: boolean; agentData?: Customer; type?: string }>({ isOpen: false });
  const [popupActionButtonDisable, setPopupActionButtonDisable] = useState<boolean>(false);

  const [isLeadManagerChanging, setLeadManagerChanging] = useState(false);
  const [showLeadManagerReasonModal, setLeadManagerShowReasonModal] = useState(false);
  const [selectedLeadManager, setSelectedLeadManager] = useState<Customer>();
  const [leadManagerConfirmation, setLeadManagerConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });

  const [isGroupManagerChanging, setGroupManagerChanging] = useState(false);
  const [showGroupManagerReasonModal, setGroupManagerShowReasonModal] = useState(false);
  const [selectedGroupManager, setSelectedGroupManager] = useState<Customer>();
  const [groupManagerConfirmation, setGroupManagerConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });
  
  const [isTelecallerChanging, setTelecallerChanging] = useState(false);
  const [isIntercityUserChanging, setIsIntercityUserChanging] = useState(false);
  const [showTelecallerReasonModal, setTelecallerShowReasonModal] = useState(false);
  const [showIntercityUserReasonModal, setIntercityUserShowReasonModal] = useState(false);
  const [selectedTelecaller, setSelectedTelecaller] = useState<Customer>();
  const [telecallerConfirmation, setTelecallerConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });
  const [intercityConfirmation, setIntercityConfirmation] = useState<{ isOpen?: boolean; agentData?: Customer }>({ isOpen: false });
  
  let includeIds: (string | undefined)[] = [];
  if (leadState?.leadDetails?.serviceAdvisorLead) {
    includeIds =
      appSettings?.data?.serviceAdvisorSettings?.staffMembers?.map(
        (s) => s._id
      ) || [];
  }
  if (leadState?.leadDetails?.bodyShopLead) {
    includeIds =
      appSettings?.data?.bodyShopSettings?.staffMembers?.map((s) => s._id) ||
      [];
  }

  const onChangeLeadManager = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.leadManager?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setLeadManagerConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.leadManager !== null &&
      leadState?.leadDetails?.leadManager !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setLeadManagerShowReasonModal(true);
      setSelectedLeadManager(agent);
    } else {
      setLeadManagerChanging(true);
      updateAssignee(
        leadState.leadDetails?._id || '',
        {leadManagerId : agent._id, type: LeadAssigneeType.LeadManager},
        '',
        () => {
          setLeadManagerChanging(false);
          props.onUpdate?.();
          setLeadManagerConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "Lead Manager assigned successfully"
          );
        },
        (error) => {
          if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
          }
          setLeadManagerConfirmation({})
          setPopupActionButtonDisable(false)
          setLeadManagerChanging(false);
          setSelectedLeadManager(undefined);
        }
      );
    }
  };

  const onChangeGroupManager = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.groupManager?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setGroupManagerConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.groupManager !== null &&
      leadState?.leadDetails?.groupManager !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setGroupManagerShowReasonModal(true);
      setSelectedGroupManager(agent);
    } else {
      setGroupManagerChanging(true);
      updateAssignee(
        leadState.leadDetails?._id || '',
        {groupManagerId : agent._id, type: LeadAssigneeType.GroupManager},
        '',
        () => {
          setGroupManagerChanging(false);
          props.onUpdate?.();
          setGroupManagerConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "Group Manager assigned successfully"
          );
        },
        (error) => {
          if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
          }
          setGroupManagerConfirmation({})
          setPopupActionButtonDisable(false)
          setGroupManagerChanging(false);
          setSelectedGroupManager(undefined);
        }
      );
    }
  };

  const onChangeTelecaller = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.telecaller?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setTelecallerConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.telecaller !== null &&
      leadState?.leadDetails?.telecaller !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setTelecallerShowReasonModal(true);
      setSelectedTelecaller(agent);
    } else {
      setTelecallerChanging(true);
      updateAssignee(
        leadState.leadDetails?._id || '',
        {telecallerId : agent._id, type: LeadAssigneeType.Telecaller},
        '',
        () => {
          setTelecallerChanging(false);
          props.onUpdate?.();
          setTelecallerConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "Telecaller assigned successfully"
          );
        },
        (error) => {
          if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
          }
          setTelecallerConfirmation({})
          setPopupActionButtonDisable(false)
          setTelecallerChanging(false);
          setSelectedTelecaller(undefined);
        }
      );
    }
  };

  const onChangeInterCityUser = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.intercityUser?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setIntercityConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.intercityUser !== null &&
      leadState?.leadDetails?.intercityUser !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setIntercityUserShowReasonModal(true);
      setSelectedInterCityUser(agent);
    } else {
      setIsIntercityUserChanging(true);
      updateAssignee(
        leadState.leadDetails?._id || '',
        {intercityUserId : agent._id, type: LeadAssigneeType.IntercityUser},
        '',
        () => {
          setIsIntercityUserChanging(false);
          props.onUpdate?.();
          setIntercityConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "Intercity User assigned successfully"
          );
        },
        (error) => {
          if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
          }
          setIntercityConfirmation({})
          setPopupActionButtonDisable(false)
          setIsIntercityUserChanging(false);
          setSelectedInterCityUser(undefined);
        }
      );
    }
  };

  const onChangeCrmAgent = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.currentCRMAgent?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setCallCenterExeAssignConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.currentCRMAgent !== null &&
      leadState?.leadDetails?.currentCRMAgent !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setShowReasonModal(true);
      setSelectedCRM(agent);
    } else {
      setCrmAgentChanging(true);
      assignCrmAgent(
        agent._id || "",
        leadState.leadDetails?._id,
        "",
        () => {
          setCrmAgentChanging(false);
          props.onUpdate?.();
          setCallCenterExeAssignConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "Support Executive assigned successfully"
          );
          // toastr.success(
          //   "Success",
          //   "Transaction Manager assigned successfully"
          // );
        },
        (error) => {
          if (error?.response?.data?.data?.message) {
            toastr.error("Error", error?.response?.data?.data?.message);
          }
          setPopupActionButtonDisable(false)
          setCrmAgentChanging(false);
          setSelectedCRM(undefined);
        }
      );
    }
  };

  const onChangeLeadHeadAssignee = (agent: Customer) => {
    setPopupActionButtonDisable(true)
    if (leadState?.leadDetails?.leadAssigneeHead?._id === agent?._id) {
      setPopupActionButtonDisable(false)
      setLeadHeadAssignConfirmation({})
      return;
    }
    if (
      leadState?.leadDetails?.leadAssigneeHead !== null &&
      leadState?.leadDetails?.leadAssigneeHead !== undefined
    ) {
      setPopupActionButtonDisable(false)
      setLeadAssigneeHeadShowReasonModal(true);
      setSelectedLeadAssigneeHead(agent);
    } else {
      setLeadAssigneeHeadChanging(true);
      assignLeadAssigneeHead(
        agent._id || "",
        leadState.leadDetails?._id,
        "",
        () => {
          setLeadAssigneeHeadChanging(false);
          props.onUpdate?.();
          setLeadHeadAssignConfirmation({})
          setPopupActionButtonDisable(false)
          toastr.success(
            "Success",
            "City Head Executive assigned successfully"
          );
          // toastr.success(
          //   "Success",
          //   "Transaction Manager assigned successfully"
          // );
        },
        (error) => {
          if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
          }
          setLeadHeadAssignConfirmation({})
          setPopupActionButtonDisable(false)
          setLeadAssigneeHeadChanging(false);
          setSelectedLeadAssigneeHead(undefined);
        }
      );
    }
  };

  const onSubmitModalCRM = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setCrmAgentChanging(true);
    assignCrmAgent(
      agent?._id || "",
      leadState.leadDetails?._id,
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setCrmAgentChanging(false);
        toastr.success(
          "Success",
          "Support Executive assigned successfully"
        );
        // toastr.success(
        //   "Success",
        //   "Transaction Manager assigned successfully"
        // );
      },
      (error) => {
        setCrmAgentChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedCRM(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSubmitLeadAssigneeHead = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setLeadAssigneeHeadChanging(true);
    assignLeadAssigneeHead(
      agent?._id || "",
      leadState.leadDetails?._id,
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setLeadAssigneeHeadShowReasonModal(false);
        setLeadAssigneeHeadChanging(false);
        toastr.success(
          "Success",
          "City Head assigned successfully"
        );
       
      },
      (error) => {
        setLeadAssigneeHeadShowReasonModal(false);
        setLeadAssigneeHeadChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedLeadAssigneeHead(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSubmitLeadManagerHead = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setLeadManagerChanging(true);
    updateAssignee(
      leadState.leadDetails?._id || '',
      {leadManagerId : agent?._id, type: LeadAssigneeType.LeadManager},
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setLeadManagerShowReasonModal(false);
        setLeadManagerChanging(false);
        toastr.success(
          "Success",
          "Lead Manager assigned successfully"
        );
       
      },
      (error) => {
        setLeadManagerShowReasonModal(false);
        setLeadManagerChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedLeadManager(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSubmitGroupManagerHead = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setGroupManagerChanging(true);
    updateAssignee(
      leadState.leadDetails?._id || '',
      {groupManagerId : agent?._id, type: LeadAssigneeType.GroupManager},
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setGroupManagerShowReasonModal(false);
        setGroupManagerChanging(false);
        toastr.success(
          "Success",
          "Group Manager assigned successfully"
        );
       
      },
      (error) => {
        setGroupManagerShowReasonModal(false);
        setGroupManagerChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedGroupManager(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSubmitTelecallerHead = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setTelecallerChanging(true);
    updateAssignee(
      leadState.leadDetails?._id || '',
      {telecallerId : agent?._id, type: LeadAssigneeType.Telecaller},
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setTelecallerShowReasonModal(false);
        setTelecallerChanging(false);
        toastr.success(
          "Success",
          "Telecaller assigned successfully"
        );
       
      },
      (error) => {
        setTelecallerShowReasonModal(false);
        setTelecallerChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedTelecaller(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSumbitSalesExecutive = (
    isReqSalesPerson: boolean,
    salesExecuitive?: Customer,
    leadReason?: LeadAssigneeChangeReason | undefined
  ) => {
    setSalesPersonChanging(true);
    assignSalesPerson(
      {
        salesPersonId: salesExecuitive?._id || "",
        customerReqSalesPerson: isReqSalesPerson,
        salesChangeReasonId: leadReason?._id || "",
      },
      leadState.leadDetails?._id,
      () => {
        props.onUpdate?.();
        toastr.success("Success", "Transaction Manager assigned successfully");
        // toastr.success("Success", "Support Executive assigned successfully");
        setSalesPersonChanging(false);
      },
      (error) => {
        setSalesPersonChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedSalesPerson(undefined);
      }
    );
    setShowSalesReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onSubmitIntercityUser = (
    agent: Customer | undefined,
    leadReason: LeadAssigneeChangeReason | undefined
  ) => {
    setIsIntercityUserChanging(true);
    updateAssignee(
      leadState.leadDetails?._id || '',
      {intercityUserId : agent?._id, type: LeadAssigneeType.IntercityUser},
      leadReason?._id || "",
      () => {
        props.onUpdate?.();
        setIntercityUserShowReasonModal(false);
        setIsIntercityUserChanging(false);
        toastr.success(
          "Success",
          "Intercity User assigned successfully"
        );
       
      },
      (error) => {
        setIntercityUserShowReasonModal(false);
        setIsIntercityUserChanging(false);
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        }
        setSelectedInterCityUser(undefined);
      }
    );
    setShowReasonModal(false);
    setReason(undefined);
    setSelectReason(true);
  };

  const onChangeSalesExecuitive = (
    isReqSalesPerson: boolean,
    salesExecuitive?: Customer
  ) => {
    setPopupActionButtonDisable(true)
    if (
      leadState?.leadDetails?.currentSalesPerson?._id === salesExecuitive?._id
    ) {
      setPopupActionButtonDisable(false)
      return;
    }
    if (
      leadState.leadDetails?.currentSalesPerson !== null &&
      leadState?.leadDetails?.currentSalesPerson !== undefined &&
      leadState?.leadDetails?.currentSalesPerson?._id !== salesExecuitive?._id
    ) {
      setPopupActionButtonDisable(false)
      setShowSalesReasonModal(true);
      setSelectedSalesPerson(salesExecuitive);
    } else {
      setSalesPersonChanging(true);
      assignSalesPerson(
        {
          salesPersonId: salesExecuitive?._id || "",
          customerReqSalesPerson: isReqSalesPerson,
        },
        leadState.leadDetails?._id,
        () => {
          props.onUpdate?.();
          setTransactionManagerConfirmation({});
          toastr.success("Success", "Transaction Manager assigned successfully");
          // toastr.success("Success", "Support Executive assigned successfully");
          setPopupActionButtonDisable(false)
          setSalesPersonChanging(false);
        },
        (error) => {
          setSalesPersonChanging(false);
          if (error?.response?.data?.data?.message) {
            toastr.error("Error", error?.response?.data?.data?.message);
          }
          setSelectedSalesPerson(undefined);
          setPopupActionButtonDisable(false)
        }
      );
    }
  };

  const cityIds = leadState?.leadDetails?.cities ? [leadState?.leadDetails?.cities] : []

  return leadState.leadDetails ? (
    <div className="p-4 accordion__body border-bottom">
      {/* {renderCallCenterExecutiveConfirmation()} */}
      {((canAssignLeadManager && !leadState.leadDetails?.leadManager) ||
        (canUpdateLeadManager && !!leadState.leadDetails?.leadManager)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold">
            Lead Manager
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set Lead Manager"
            )}>
              <AutoCompleteInput
                loadingText={isLeadManagerChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedLeadManager
                    ? leadState.leadDetails?.leadManager
                    : selectedLeadManager
                }
                placeholder={"Lead Manager"}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.leadManager !== null &&
                    leadState?.leadDetails?.leadManager !== undefined
                  ) {
                      setLeadManagerShowReasonModal(true);
                      setSelectedLeadManager(val);
                    } else {
                    setLeadManagerConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                apiUrl="/api/user/assignees/list"
                payload={{ cityId: leadState.leadDetails?.cityDetails?._id }}
                valueField={"name"}
                // showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchAssignee({
                    query,
                    hideBlocked: true,
                    // cityId: leadState.leadDetails?.cityDetails?._id ,
                    accountType: AssigneeAccountType.LeadManager
                  });
                }}
                disabled={!leadState.leadDetails.cities}
              />
            </div>
          </div>
        )}

      {((canAssignLeadAssigneeHead && !leadState.leadDetails?.leadAssigneeHead) ||
        (canLeadAssigneeHead && !!leadState.leadDetails?.leadAssigneeHead)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold">
            City Head
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set City Head"
            )}>
              <AutoCompleteInput
                loadingText={isLeadAssigneeHeadChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedLeadAssigneeHead
                    ? leadState.leadDetails?.leadAssigneeHead
                    : selectedLeadAssigneeHead
                }
                placeholder={"City Head"}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.leadAssigneeHead !== null &&
                    leadState?.leadDetails?.leadAssigneeHead !== undefined
                  ) {
                    setLeadAssigneeHeadShowReasonModal(true);
                    setSelectedLeadAssigneeHead(val);
                  } else {
                    setLeadHeadAssignConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                apiUrl="/api/user/city-heads/list"
                payload={{ cityId: leadState.leadDetails?.cityDetails?._id }}
                valueField={"name"}
                showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchLeadAssigneeHead({
                    query,
                    hideBlocked: true,
                    cityId: leadState.leadDetails?.cityDetails?._id 
                  });
                }}
                disabled={!leadState.leadDetails.cities}
              />
            </div>
          </div>
        )}

      {((canAssignGroupManager && !leadState.leadDetails?.groupManager) ||
        (canUpdateGroupManager && !!leadState.leadDetails?.groupManager)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold">
            Group Manager
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set Group Manager"
            )}>
              <AutoCompleteInput
                loadingText={isGroupManagerChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedGroupManager
                    ? leadState.leadDetails?.groupManager
                    : selectedGroupManager
                }
                placeholder={"Group Manager"}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.groupManager !== null &&
                    leadState?.leadDetails?.groupManager !== undefined
                  ) {
                    setGroupManagerShowReasonModal(true);
                    setSelectedGroupManager(val);
                  } else {
                    setGroupManagerConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                apiUrl="/api/user/assignees/list"
                payload={{ cityId: leadState.leadDetails?.cityDetails?._id }}
                valueField={"name"}
                // showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchAssignee({
                    query,
                    hideBlocked: true,
                    // cityId: leadState.leadDetails?.cityDetails?._id ,
                    accountType: AssigneeAccountType.GroupManager
                  });
                }}
                disabled={!leadState.leadDetails.cities}
              />
            </div>
          </div>
        )}

      {((canAssignSalesPerson && !leadState.leadDetails?.currentSalesPerson) ||
        (canUpdateSalesPerson &&
          !!leadState.leadDetails?.currentSalesPerson)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold d-flex">
              Transaction Manager
              {/* Support Executive */}
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set Transaction Manager"
            )}>
              <SalesPersonsAutoCompleteInput
                loadingText={isSalesPersonChanging ? "Assigning ..." : ""}
                defaultValue={
                  selectedSalesPerson
                    ? selectedSalesPerson
                    : leadState.leadDetails?.currentSalesPerson
                }
                placeholder={"Transaction Manager"}
                // placeholder={"Support Executive"}
                onChange={(salesPerson: Customer) => {
                  if (
                    leadState.leadDetails?.currentSalesPerson !== null &&
                    leadState?.leadDetails?.currentSalesPerson !== undefined &&
                    leadState?.leadDetails?.currentSalesPerson?._id !== salesPerson?._id
                  ) {
                    setShowSalesReasonModal(true);
                    setSelectedSalesPerson(salesPerson);
                  } else if (
                    leadState?.leadDetails?.currentSalesPerson?._id === salesPerson?._id
                  ) {
                    return;
                  } else {
                    setTransactionManagerConfirmation({
                      isOpen: true,
                      salesPersonReqStatus: isCustomerReqSalesPerson,
                      agentData: salesPerson,
                      type: 'optOut'
                    })
                  }
                }}
                // apiUrl="api/user/staffs/list"
                apiUrl="api/user/sales-persons"
                valueField={"name"}
                showroomId={leadState.leadDetails?.showroomId}
                dataLoader={(query?: string) => {
                  return api.customer.searchSalesPerson(
                    { query, hideBlocked: true, ...(cityIds.length ? { cityIds } : {}) },
                    "lead-assignees",
                    // leadState?.leadDetails?.company?._id,
                  );
                  // return api.customer.searchStaff({
                  //   query,
                  //   hideBlocked: true,
                  // });
                }}
                disabled={updating ||  !leadState.leadDetails.cities}
                hideBlocked={true}
                includeIds={includeIds}
              />
          </div>
          </div>
        )}

      {((canAssignTelecaller && !leadState.leadDetails?.telecaller) ||
        (canUpdateTelecaller && !!leadState.leadDetails?.telecaller)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold">
            Telecaller
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Telecaller should be mapped in order to set Telecaller"
            )}>
              <AutoCompleteInput
                loadingText={isTelecallerChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedTelecaller
                    ? leadState.leadDetails?.telecaller
                    : selectedTelecaller
                }
                placeholder={"Telecaller"}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.telecaller !== null &&
                    leadState?.leadDetails?.telecaller !== undefined
                  ) {
                    setTelecallerShowReasonModal(true);
                    setSelectedTelecaller(val);
                  } else {
                    setTelecallerConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                apiUrl="/api/user/assignees/list"
                payload={{ cityId: leadState.leadDetails?.cityDetails?._id }}
                valueField={"name"}
                // showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchAssignee({
                    query,
                    hideBlocked: true,
                    // cityId: leadState.leadDetails?.cityDetails?._id ,
                    accountType: AssigneeAccountType.Telecaller
                  });
                }}
                disabled={!leadState.leadDetails.cities}
              />
            </div>
          </div>
        )}

      {((canAssignCRMAgent && !leadState.leadDetails?.currentCRMAgent) ||
        (canUpdateCrmAgent && !!leadState.leadDetails?.currentCRMAgent)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold">
              Support Executive
              {/* Transaction Manager */}
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set Support Executive"
            )}>
              <AutoCompleteInput
                loadingText={isCrmAgentChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedCRM
                    ? leadState.leadDetails?.currentCRMAgent
                    : selectedCRM
                }
                placeholder={"Support Executive"}
                // placeholder={"Transaction Manager"}
                // onChange={(val) => setAgentAssignConfirmation({ isOpen: true, agentData: val })}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.currentCRMAgent !== null &&
                    leadState?.leadDetails?.currentCRMAgent !== undefined
                  ) {
                    setShowReasonModal(true);
                    setSelectedCRM(val);
                  } else if (
                    leadState?.leadDetails?.currentSalesPerson?._id === val?._id
                  ) {
                    return;
                  } else {
                    setCallCenterExeAssignConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                // apiUrl="api/user/staffs/list"
                apiUrl="api/user/crm-agents"
                valueField={"name"}
                showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchCrmAgents(
                    { query, hideBlocked: true, ...(cityIds.length ? { cityIds } : {}) },
                    "lead-assignees",
                    leadState?.leadDetails?.company?._id,
                  );
                  // return api.customer.searchStaff({
                  //   query,
                  //   hideBlocked: true,
                  // });
                }}
                disabled={!leadState.leadDetails.cities}
              />
          </div>
          </div>
        )}

      {((canAssignIntercityUser && !leadState.leadDetails?.intercityUser) ||
        (canUpdateIntercityUser &&
          !!leadState.leadDetails?.intercityUser)) && (
          <div className="form-group mb-3">
            <label htmlFor="" className="font-sm font-weight-semibold d-flex">
              Intercity User
            </label>
            <div onClick={()=>!leadState?.leadDetails?.cities &&  toastr.error(
              "Error",
              "Sorry! Lead City should be mapped in order to set Intercity User"
            )}>
              <AutoCompleteInput
                loadingText={isIntercityUserChanging ? "Assigning ..." : ""}
                defaultValue={
                  !selectedInterCityUser
                    ? leadState.leadDetails?.intercityUser
                    : selectedInterCityUser
                }
                placeholder={"Intercity User"}
                onChange={(val) => {
                  if (
                    leadState?.leadDetails?.intercityUser !== null &&
                    leadState?.leadDetails?.intercityUser !== undefined
                  ) {
                    setIntercityUserShowReasonModal(true);
                    setSelectedInterCityUser(val);
                  } else {
                    setIntercityConfirmation({ isOpen: true, agentData: val })
                  }
                }}
                apiUrl="/api/user/assignees/list"
                payload={{ cityId: leadState.leadDetails?.cityDetails?._id }}
                valueField={"name"}
                // showroomId={leadState.leadDetails?.showroomId}
                hideBlocked={true}
                dataLoader={(query?: string) => {
                  return api.customer.searchAssignee({
                    query,
                    hideBlocked: true,
                    // cityId: leadState.leadDetails?.cityDetails?._id ,
                    accountType: AssigneeAccountType.IntercityUser
                  });
                }}
                disabled={!leadState.leadDetails.cities}
              />
          </div>
          </div>
      )}

      <ConfirmationModal
        isOpen={callCenterExeAssignConfirmation.isOpen}
        title="Assign Support Executive"
        message="Are you sure you want to assign Support Executive to this lead?"
        onConfirm={() => onChangeCrmAgent(callCenterExeAssignConfirmation.agentData!)}
        onCancel={() => setCallCenterExeAssignConfirmation({})}
        isLoading={popupActionButtonDisable}
      />

      <ConfirmationModal
        isOpen={leadHeadAssignConfirmation.isOpen}
        title="Assign City Head"
        message="Are you sure you want to assign City Head to this lead?"
        onConfirm={() => onChangeLeadHeadAssignee(leadHeadAssignConfirmation.agentData!)}
        onCancel={() => setLeadHeadAssignConfirmation({})}
        isLoading={popupActionButtonDisable}
      />

      <ConfirmationModal
        isOpen={agentTransactionManagerConfirmation?.isOpen}
        title="Assign Transaction Manager"
        message="Are you sure you want to assign Transaction Manager to this lead?"
        onConfirm={() =>  onChangeSalesExecuitive(agentTransactionManagerConfirmation?.salesPersonReqStatus!, agentTransactionManagerConfirmation?.agentData)}
        onCancel={() =>  setTransactionManagerConfirmation({})}
        isLoading={popupActionButtonDisable}
      />

      <ConfirmationModal
        isOpen={leadManagerConfirmation.isOpen}
        title="Assign Lead Manager"
        message="Are you sure you want to assign Lead Manager to this lead?"
        onConfirm={() => onChangeLeadManager(leadManagerConfirmation.agentData!)}
        onCancel={() => setLeadManagerConfirmation({})}
        isLoading={popupActionButtonDisable}
      /> 

       <ConfirmationModal
        isOpen={groupManagerConfirmation.isOpen}
        title="Assign Group Manager"
        message="Are you sure you want to assign Group Manager to this lead?"
        onConfirm={() => onChangeGroupManager(groupManagerConfirmation.agentData!)}
        onCancel={() => setGroupManagerConfirmation({})}
        isLoading={popupActionButtonDisable}
      />
       <ConfirmationModal
        isOpen={telecallerConfirmation.isOpen}
        title="Assign Telecaller"
        message="Are you sure you want to assign Telecaller to this lead?"
        onConfirm={() => onChangeTelecaller(telecallerConfirmation.agentData!)}
        onCancel={() => setTelecallerConfirmation({})}
        isLoading={popupActionButtonDisable}
      />
       <ConfirmationModal
        isOpen={intercityConfirmation.isOpen}
        title="Assign Intercity User"
        message="Are you sure you want to assign Intercity User to this lead?"
        onConfirm={() => onChangeInterCityUser(intercityConfirmation.agentData!)}
        onCancel={() => setIntercityConfirmation({})}
        isLoading={popupActionButtonDisable}
      />

      <PersonnelChangeModal
        isVisible={showReasonModal}
        title="Support Executive"
        placeholder="Support Executive"
        selectedPerson={selectedCRM}
        setSelectedPerson={setSelectedCRM}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          setSelectedCRM(undefined);
          setShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={onSubmitModalCRM}
        showroomId={leadState?.leadDetails?.showroomId}
        cityIds={cityIds}
        companyId={leadState?.leadDetails?.company?._id}
        hideBlocked={true}
        apiUrl="api/user/crm-agents"
        useSpecialInput="regular"
      />
      
      <PersonnelChangeModal
        isVisible={showSalesReasonModal}
        title="Transaction Manager"
        placeholder="Transaction Manager"
        selectedPerson={selectedSalesPerson}
        setSelectedPerson={setSelectedSalesPerson}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          if (leadState?.leadDetails?.customerReqSalesPerson === true) {
            setIsCustomerReqSalesPerson(true);
          } else {
            setIsCustomerReqSalesPerson(false);
          }
          setSelectedSalesPerson(undefined);
          setShowSalesReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={(person, reasonData) => onSumbitSalesExecutive(isCustomerReqSalesPerson, person, reasonData)}
        showroomId={leadState?.leadDetails?.showroomId}
        cityIds={cityIds}
        isLoading={isSalesPersonChanging || updating}
        includeIds={includeIds}
        hideBlocked={true}
        apiUrl="api/user/sales-persons"
        useSpecialInput="salesPerson"
      />
      
      <PersonnelChangeModal
        isVisible={showIntercityUserReasonModal}
        title="Intercity user"
        placeholder="Intercity user"
        selectedPerson={selectedInterCityUser}
        setSelectedPerson={setSelectedInterCityUser}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          setSelectedInterCityUser(undefined);
          setIntercityUserShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={onSubmitIntercityUser}
        showroomId={leadState?.leadDetails?.showroomId}
        hideBlocked={true}
        apiUrl="api/user/assignees/list?hideBlocked=true"
        useSpecialInput="assignee"
        accountType={AssigneeAccountType.IntercityUser}
      />
      
      <PersonnelChangeModal
        isVisible={showLeadManagerReasonModal}
        title="Lead Manager"
        placeholder="Lead Manager"
        selectedPerson={selectedLeadManager}
        setSelectedPerson={setSelectedLeadManager}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          setSelectedLeadManager(undefined);
          setLeadManagerShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={onSubmitLeadManagerHead}
        showroomId={leadState?.leadDetails?.showroomId}
        hideBlocked={true}
        apiUrl="api/user/assignees/list?hideBlocked=true"
        useSpecialInput="assignee"
        accountType={AssigneeAccountType.LeadManager}
      />
      
      <PersonnelChangeModal
        isVisible={showGroupManagerReasonModal}
        title="Group Manager"
        placeholder="Group Manager"
        selectedPerson={selectedGroupManager}
        setSelectedPerson={setSelectedGroupManager}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          setSelectedGroupManager(undefined);
          setGroupManagerShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={onSubmitGroupManagerHead}
        showroomId={leadState?.leadDetails?.showroomId}
        hideBlocked={true}
        apiUrl="api/user/assignees/list?hideBlocked=true"
        useSpecialInput="assignee"
        accountType={AssigneeAccountType.GroupManager}
      />
      
      <PersonnelChangeModal
        isVisible={showTelecallerReasonModal}
        title="Telecaller"
        placeholder="Telecaller"
        selectedPerson={selectedTelecaller}
        setSelectedPerson={setSelectedTelecaller}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          setSelectedTelecaller(undefined);
          setTelecallerShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={onSubmitTelecallerHead}
        showroomId={leadState?.leadDetails?.showroomId}
        hideBlocked={true}
        apiUrl="api/user/assignees/list?hideBlocked=true"
        useSpecialInput="assignee"
        accountType={AssigneeAccountType.Telecaller}
      />

      <PersonnelChangeModal
        isVisible={showLeadAssigneeHeadReasonModal}
        title="City Head"
        placeholder="City Head"
        selectedPerson={selectedLeadAssigneeHead}
        setSelectedPerson={setSelectedLeadAssigneeHead}
        changeReasons={changeReasons}
        reason={reason}
        setReason={setReason}
        selectReason={selectReason}
        setSelectReason={setSelectReason}
        closeModal={() => {
          // Reset states as in your Cancel button callback
          setSelectedLeadAssigneeHead(undefined);
          setLeadAssigneeHeadShowReasonModal(false);
          setReason(undefined);
          setSelectReason(true);
        }}
        onSubmit={(person, reasonDetails) => onSubmitLeadAssigneeHead(person, reasonDetails)}
        showroomId={leadState.leadDetails?.showroomId}
        apiUrl="api/user/staffs/list?hideBlocked=true"
        hideBlocked={true}
      />
    </div>
  ) : (
    <div className="p-4 accordion__body border-bottom"></div>
  );
};

export default AssignUsers;


